import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from '@core/models';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import * as moment from 'moment';

@Component({
	selector: 'app-add-view-replies',
	templateUrl: './add-view-replies.component.html',
	styleUrls: ['./add-view-replies.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AddViewRepliesComponent implements OnInit {
	redirect: string;
	assignAd: string;
	repliesListArr: any = [];
	loading: boolean = false;
	commentList: Object;
	reply: string;
	ad: Object;
	show: boolean = false;
	toggleButton: boolean = false;
	tempstatus: any = 1;
	page: any = 1;
	user: User = this.auth.user();
	tempListArr: any = [];
	nextPage: any;
	box: boolean = false;
	showLoad: boolean = false;
	load: boolean = true;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		private api: ApiService,
		private router: Router,
		public locale: LocaleService,
		private auth: AuthService,
		private route: ActivatedRoute,
		private dialogRef: MatDialogRef<AddViewRepliesComponent>
	) {}

	ngOnInit(): void {
		this.showAllReplies();
		this.route.params.subscribe((params: Params) => {
			this.route.queryParams.subscribe((queries: Params) => {
				if (queries['redirect'] !== undefined) {
					this.redirect = queries['redirect'];
				}

				if (queries['from']) {
					this.redirect = queries['from'];
				}

				if (queries['id'] !== undefined) {
					this.assignAd = queries['id'];
				}
			});
		});
	}

	toggle(id: any, status: any) {
		if (status === '1') {
			status = '2';
		} else {
			status = '1';
		}

		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('commentID', id);
		formData.append('userID', this.user['userID']);
		formData.append('adID', this.data['adID']);
		formData.append('status', status);
		this.loading = true;
		this.api.hideComment(formData).subscribe((res) => {
			if (res.status === '1') {
				this.page = 1;
				this.repliesListArr = [];
				this.showAllReplies();
				this.loading = false;
			}
		});
	}

	showAllReplies() {
		if (this.user) {
			const formData: FormData = new FormData();
			formData.append('lang', this.locale.lang);
			formData.append('commentID', this.data.commentID);
			formData.append('page', this.page);
			formData.append('userID', this.user['userID']);

			this.api.commentReplies(formData).subscribe((res) => {
				for (let i = 0; i < res['response']['data']['length']; i++) {
					res['response']['data'][i]['createdAt'] = moment.unix(res['response']['data'][i]['createdAt']).fromNow(true);
				}

				this.nextPage = res['response']['pages'];

				if (this.page >= this.nextPage) {
					this.load = false;
				} else {
					this.load = true;
				}

				this.tempListArr = res['response']['data'];
				this.repliesListArr = [...this.repliesListArr, ...this.tempListArr];
				this.box = true;
				this.showLoad = false;
			});
		} else {
			const formData: FormData = new FormData();
			formData.append('lang', this.locale.lang);
			formData.append('commentID', this.data.commentID);
			formData.append('page', this.page);
			this.api.commentReplies(formData).subscribe((res) => {
				for (let i = 0; i < res['response']['data']['length']; i++) {
					res['response']['data'][i]['createdAt'] = moment.unix(res['response']['data'][i]['createdAt']).fromNow(true);
				}

				this.nextPage = res['response']['pages'];

				if (this.page >= this.nextPage) {
					this.load = false;
				} else {
					this.load = true;
				}

				this.tempListArr = res['response']['data'];
				this.repliesListArr = [...this.repliesListArr, ...this.tempListArr];
				this.box = true;
				this.showLoad = false;
			});
		}
	}

	addReply(reply, id: any) {
		if (this.user) {
			const replyFormData: FormData = new FormData();
			replyFormData.append('lang', this.locale.lang);
			replyFormData.append('userID', this.user['userID']);
			replyFormData.append('adID', this.data['adID']);
			replyFormData.append('comment', reply);
			replyFormData.append('commentID', id);
			this.api.addComment(replyFormData).subscribe((response) => {
				this.repliesListArr = [];
				this.reply = null;
				this.page = 1;
				this.showAllReplies();
				// this.dialogRef.close(id)
			});
		} else {
			this.router.navigate(['/login'], {
				queryParams: {
					redirect: 'ad/',
					id: this.data['adID'],
				},
			});
		}
	}

	getToggle(comment) {
		this.toggleButton =
			(this.user['userID'] === this.data['userAd'] && (this.data['vip'] === '1' || this.data['premium'] === '1')) ||
			comment['userID'] === this.user['userID'];

		return this.toggleButton;
	}

	LoadMore() {
		this.page++;
		if (this.page <= this.nextPage) {
			this.showLoad = true;
			this.showAllReplies();
		}
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
